.container {
  width: auto;
  flex: 1;
}

.button {
  font-weight: 400;
}
